export default "__VITE_ASSET__DZ8$5h82__"